// extracted by mini-css-extract-plugin
export var configurationSection = "_rf-0";